import _v from './vars';
import _m from './mappings';
import _u from './util';
import callSalApi from './api-query';
import _filt from  './filters';

const _fn = {
	
	'checkQueryOnLoad': function(e) { // Runs on initial load or on back + forward button popstate. Does not run on filter submit.
	
		// All Query Parameters present to Render Main Widget Page
		if (_u.checkQuery('specialty') != null && _u.checkQuery('dma') != null && _u.checkQuery('city') != null && _u.checkQuery('state') != null && _u.checkQuery('region') != null && _u.checkQuery('yoe') != null) {
			
			_u.qS('.slry-filt-bar-main .spec-input .slry-input-label').innerHTML = decodeURIComponent(_u.checkQuery('specialty').replace(/\+/g,'%20'));	
			_u.qS('.slry-filt-bar-main .spec-input .slry-sel-opt').forEach(function(elem) {
				elem.classList.remove('selected');
			});
			_u.qS('.slry-filt-bar-main .spec-input .slry-sel-opt').forEach(function(elem) {
				if (elem.innerHTML.trim() == _u.qS('.slry-filt-bar-main .spec-input .slry-input-label').innerHTML.trim()) {
					elem.classList.add('selected');
				}
			});
			
			_u.qS('.slry-filt-bar-main .slry-input.loc-input').value = decodeURIComponent(_u.checkQuery('city').replace(/\+/g,'%20')) + ', ' + decodeURIComponent(_u.checkQuery('state'));
			
			_u.qS('.slry-filt-bar-main .yoe-input .slry-sel-opt').forEach(function(elem) {
				elem.classList.remove('selected');
			});
			_u.qS('.slry-filt-bar-main .yoe-input .slry-sel-opt').forEach(function(elem) {
				if (elem.getAttribute('data-yr') == decodeURIComponent(_u.checkQuery('yoe'))) {
					elem.classList.add('selected');
					_u.qS('.slry-filt-bar-main .yoe-input .slry-input-label').innerHTML = elem.innerHTML;
				}
			});
			
			_u.qS('.slry-filt-bar-main .emp-input .slry-sel-opt').forEach(function(elem) {
				elem.classList.remove('selected');
			});
			
			_v.userEmpQry = '';
			if (_u.checkQuery('emp') != null) {
				_v.userEmpQry = _u.checkQuery('emp');
			}
			_u.qS('.slry-filt-bar-main .emp-input .slry-sel-opt').forEach(function(elem) {		
				if (elem.getAttribute('data-emp') == _v.userEmpQry) {
					elem.classList.add('selected');
					_u.qS('.slry-filt-bar-main .emp-input .slry-input-label').innerHTML = elem.innerHTML;
				}
			});

			_v.userDma = decodeURIComponent(_u.checkQuery('dma').replace(/\+/g,'%20'));
			_v.userState = decodeURIComponent(_u.checkQuery('state'));
			_v.userRegion = decodeURIComponent(_u.checkQuery('region').replace(/\+/g,'%20'));
			
			_u.qS('.slry-welc-abt').classList.remove('active');
			_u.qS('.slry-section.survey').classList.remove('active');
			_u.qS('.slry-body').classList.remove('hide-bg');
			_u.qS('.slry-main').classList.add('active');
			_u.qS('.slry-body').classList.add('main');
			
			_filt.handleSubmit(e);

		}
		
		// Survey Page
		else if (window.location.pathname == '/physician-salary-explorer/survey') {		
			_u.qS('.slry-main').classList.remove('active');
			_u.qS('.slry-body').classList.remove('main');
			_u.qS('.slry-welc-abt').classList.remove('active');
			_u.qS('.slry-section.survey').classList.add('active');
			_u.qS('.slry-body').classList.add('hide-bg');
			window.scrollTo(0, 0);
			if (typeof e != 'undefined') { // If back-button popstate virtual page
				_fn.sendVpPageView();
				_fn.adLoadRefresh(122);
				document.title = 'Medscape Salary Explorer';
			}
		}
		
		// Back to Welcome
		else {
			_u.qS('.slry-main').classList.remove('active');
			_u.qS('.slry-body').classList.remove('main');
			_u.qS('.slry-section.survey').classList.remove('active');
			_u.qS('.slry-body').classList.remove('hide-bg');
			_u.qS('.slry-welc-abt').classList.add('active');
			window.scrollTo(0, 0);
			if (typeof e != 'undefined') { // If back-button popstate virtual page
				_filt.checkWelcReq();
				_fn.sendVpPageView();
				_fn.adLoadRefresh(122);
				document.title = 'Medscape Salary Explorer';
			}
			_u.qS('.slry-welc').focus();
			
		}
		
	},
	
	'getLocationLabel': function(level) {		
		let labelHtml = '';		
		if (level == 1) {
			labelHtml = 'In <span class="reg">' + _v.userLoc + '</span>';
		}
		else if (level == 2) {
			labelHtml = 'In the state of <span class="reg">' + _m.stateName[_v.userState] + '</span>';
		}
		else if (level == 3) {
			if (_v.userRegion == 'Mid Atlantic' || _v.userRegion == 'North Central' || _v.userRegion == 'South Central') {
				labelHtml = 'In the <span class="reg">' + _v.userRegion + '</span> region';
			} else {
				labelHtml = 'In the <span class="reg">' + _v.userRegion + '</span>';
			}
		}
		else if (level == 4 || level == 5) {
			labelHtml = '<span class="reg">Nationwide</span>';
		}		
		return labelHtml;		
	},
	
	'getLabels': function(elem, level) {
		if (elem.querySelector('.loc-label') != null) {
			elem.querySelector('.loc-label').innerHTML = _fn.getLocationLabel(level);
		}
		if (elem.querySelector('.spec-label') != null) {
			elem.querySelector('.spec-label').innerHTML = _m.specMap[_v.homePageId].specialist;
		}
		if (elem.querySelector('.yoe-label-wrap') != null) {			
			if (level == 5) {
				elem.querySelector('.yoe-label-wrap').innerHTML = 'for <span class="reg yoe-label">all years of experience</span>';
			} else {				
				elem.querySelector('.yoe-label-wrap').innerHTML = 'with <span class="reg yoe-label">' + _v.userYoe + ' of experience</span>';
			}
		}
		if (elem.querySelector('.setting') != null) {		
			if (_v.userEmp == 'Employed') {
				elem.querySelector('.setting').innerHTML = 'an employed setting';
			} else if  (_v.userEmp == 'Self-employed') {
				elem.querySelector('.setting').innerHTML = 'a self-employed setting';
			}
			else {
				elem.querySelector('.setting').innerHTML ='any practice setting';
			}
		}
	},

	'getLabelsGeneric': function() {	
		_v.widgNames.forEach(function(widget) {			
			if (!(_u.qS('#' + widget).offsetParent != null && _u.qS('#' + widget).getBoundingClientRect().top < window.innerHeight && _u.qS('#' + widget).getBoundingClientRect().bottom >= 0)) {
				if (_u.qS('#' + widget).querySelector('.loc-label') != null) {
					_u.qS('#' + widget).querySelector('.loc-label').innerHTML = _fn.getLocationLabel(1);
				}
				if (_u.qS('#' + widget).querySelector('.spec-label') != null) {
					_u.qS('#' + widget).querySelector('.spec-label').innerHTML = _m.specMap[_v.homePageId].specialist;
				}
				if (_u.qS('#' + widget).querySelector('.yoe-label-wrap') != null) {
					_u.qS('#' + widget).querySelector('.yoe-label-wrap').innerHTML = 'with <span class="reg yoe-label">' + _v.userYoe + ' of experience</span>';
				}
				if (_u.qS('#' + widget).querySelector('.setting') != null) {
					if (_v.userEmp == 'Employed') {						
						_u.qS('#' + widget).querySelector('.setting').innerHTML = 'an employed setting';
					} else if  (_v.userEmp == 'Self-employed') {
						_u.qS('#' + widget).querySelector('.setting').innerHTML = 'a self-employed setting';
					}
					else {
						_u.qS('#' + widget).querySelector('.setting').innerHTML = 'any practice setting';
					}
				}				
			}			
		});
	},
	
	'getYrRange': function(yoe) {
		let yrsStr = "";
		switch(true) {
			case (yoe <= 7):
				yrsStr = '1-7';
			  break;
			case (yoe >=8 && yoe <= 14):
				yrsStr = '8-14';
			  break;
			case (yoe >=15 && yoe <= 21):
				yrsStr = '15-21';		
			  break;
			case (yoe >=22 && yoe <= 28):
				yrsStr = '22-28';			
			  break;
			case (yoe >=29 && yoe <= 35):
				yrsStr = '29-35';		
			  break;
			case (yoe >=36):
				yrsStr = '36+';
			  break;
		}
		return yrsStr;
	},
	
	'formatSalary': function(sal) {
		return '$' + String(sal).replace(/(\d?\d\d)(\d\d\d$)/,',$1,$2').replace(/^,/,'');
	},
	
	'sendVpPageView': function(e) {
		try { // Place entire function in try/catch in case footer issues and Omniture undefined
			if (typeof e != 'undefined') { // Event only sent with Submit clicks
				let omniPrefix = 'mse-wfltr';
				let pSetSuffix = '';
				if (e.detail.target != window && e.detail.parentNode.classList.contains('slry-filt-bar-main')) {
					omniPrefix = 'mse-mfltr';
					if (_v.userEmpIdx == '') {
						pSetSuffix = '-all';
					} else if (_v.userEmpIdx == '1') {				
						pSetSuffix = '-empl';
					} else {
						pSetSuffix = '-self';
					}
				}
				wmdTrack(omniPrefix + '_subm-' + _m.specMap[_v.homePageId].specialty.replace(/ /g,'').substr(0,5).toLowerCase() + '-' + _v.userDma.replace(/_/g,'').substr(0,7).toLowerCase() + '-' + _v.userState.toLowerCase() + '-' + _v.userYoeRng.replace(',','|') + pSetSuffix, e.detail);
			}		
			GenPVID();
			s_md.pageURL = location.href;
			s_md.pageName = _urlClean(location.protocol + "//" + location.host + location.pathname);
			wmdPageview('',1);
		} catch(e) { console.log(e) }
	},
	
	'adLoadRefresh': function(skip) {
		try {
			let skipAd = null;
			if (typeof skip != 'undefined') {
				skipAd = skip;
			}
			
			if (DFPTargetKeys.reqHeaders.device == "MOBILE") {
				if (!_v.adAppended) { // First time page is hit
					_v.adAppended = true;
					
					webmd.ads2.sizes['1122'] = [[300,250], [300,400], [300,50], [300,51], [320,50], [320,51], "fluid"];
					webmd.ads2.defineAd({
						id: 'ads-pos-1122',
						pos: '1122'
					});
					
					//webmd.ads2.sizes['1520'] = [[2,3], [1,12], [300,254], [300,250], "fluid"];
					webmd.ads2.defineAd({
						id: 'ads-pos-1520',
						pos: '1520'
					});
					
					webmd.ads2.sizes['1420'] = [[2,3], [1,12], [300,254], [300,250], "fluid"];
					webmd.ads2.defineAd({
						id: 'ads-pos-1420',
						pos: '1420'
					});
					
					webmd.ads2.display();
				} else {
					let dfpObj = {};
					if (skipAd != 122) { // Skip 122 on Back Button to Welcome
						dfpObj['ads-pos-1122'] = true;
						dfpObj['ads-pos-1520'] = true;
						dfpObj['ads-pos-1420'] = true;
						webmd.ads2.refresh({
							id: dfpObj
						});
					}
				}
			}
			else {		
				if (!_v.adAppended) { // First time page is hit
					_v.adAppended = true;
					webmd.ads2.defineAd({
						id: 'ads-pos-141',
						pos: '141'
					});
					
					webmd.ads2.sizes['420'] = [[2,3], "fluid"];
					webmd.ads2.defineAd({
						id: 'ads-pos-420',
						pos: '420'
					});
					
					webmd.ads2.defineAd({
						id: 'ads-pos-122',
						pos: '122'
					});
					webmd.ads2.defineAd({
						id: 'ads-pos-910',
						pos: '910'
					});
					
					webmd.ads2.sizes['520'] = [[2,3], "fluid"];
					webmd.ads2.defineAd({
						id: 'ads-pos-520',
						pos: '520'
					});
					
					if (skipAd != 101) { // skip101 is set if page loaded from query string, so Ad can load naturally
						webmd.ads2.refresh();
					}
				}
				else {
					let dfpObj = {};
					if (skipAd != 122) { // Skip 122 on Back Button to Welcome
						dfpObj['ads-pos-122'] = true;
						dfpObj['ads-pos-520'] = true;
						dfpObj['ads-pos-420'] = true;
						dfpObj['ads-pos-141'] = true;
						dfpObj['ads-pos-910'] = true;
					}
					dfpObj['ads-pos-101'] = true;
					webmd.ads2.refresh({
						id: dfpObj
					});
				}			
			}
		}
		catch(e) {
			console.log(e);
		}
	}
	
}

export default _fn;